module.exports = __webpack_public_path__ + "media/images/sunbasket_july4th/bg-xs-ad736d3606ce3f21a7f66fe0656d38ba.jpg";